<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import InboxActionToggleCell from "../../_shared/_modules/inbox-action-toggle-cell"

  let props: InboxWorkflowCellProps = $props()

  const value = $derived(
    typeof props.binding.value === "string" || typeof props.binding.value === "number"
      ? String(props.binding.value)
      : "",
  )
</script>

<InboxActionToggleCell
  {value}
  options={props.binding.options.map((option) => ({
    value: option.value,
    label: option.label ?? option.name ?? option.value,
    disabled: option.disabled,
    tooltip: option.tooltip,
    tooltipContent: option.tooltipContent,
    dataTestid: option.dataTestid,
  }))}
  disabled={props.binding.disabled}
  ariaLabel={props.columnConfig.placeholder ?? props.column.label}
  onChange={(next) => props.binding.setValue(next)}
/>
